import {Link as RouterLink} from 'react-router-dom';

import styled, {css} from 'styled-components';

import {Button, mixins} from '@edna/components';

const SelectorButton = styled(Button)`
  ${mixins.flexAlign('stretch', 'center')}
  ${mixins.f2}
  font-weight: 600;
  text-transform: none;
  ${({theme}) => css`
    color: ${theme.palette.white};
    background-color: ${theme.palette.blue500};

    &:hover {
      color: ${theme.palette.white};
      background-color: ${theme.palette.blue600};
    }
  `}
`;

const SelectorDropdownItem = styled(RouterLink)`
  ${mixins.stack({size: '4', direction: 'ROW', justify: 'flex-start', align: 'center'})}
  ${mixins.f3}
  width: 100%;
  text-decoration: none;
  background-color: transparent;
  white-space: nowrap;
  cursor: pointer;
  ${({theme}) => css`
    padding: ${theme.spacing.s2} ${theme.spacing.s4};
    color: ${theme.palette.black};

    &:hover {
      color: ${theme.palette.black};
      background-color: ${theme.palette.grey50};
    }

    &:disabled {
      cursor: default;
    }
  `}
`;

export {SelectorButton, SelectorDropdownItem};
